import { queryClient } from '../../../../../App'
import { useRemoteClientPost } from '../../../../../configs/http-client'
import { useLocalStorage } from '../../../../../remote/local-storage'
import { useToast } from '../../../../hooks'

export const createRoom = async (data: any) => {
  const { showToast } = useToast()
  const { httpClientPost } = useRemoteClientPost()
  const { getUnitId } = useLocalStorage()

  try {
    const response = await httpClientPost('/salas', {
      ...data,
      unidade: {
        id: getUnitId()
      }
    })
    console.log({ cRoom: response })
    showToast('Sala criada com sucesso', 'success')
    queryClient.refetchQueries({ queryKey: ['load-rooms'] })
  } catch (error) {
    console.error(error)
    showToast('Erro ao criar sala', 'error')
  }
}
